import React from "react";
import classNames from "classnames";
import { ArrowDownIcon, ArrowUpIcon } from "@icons";
import { Button } from "../Button/Button";
import type { TriggerButtonProps } from "@design-system/overlay/triggerButtonProps";
import styles from "./Collapsible.module.scss";

interface Props {
    isOpened: boolean;
    onToggle: () => void;
    panelId: string;
    children?: React.ReactNode;
    actions?: React.ReactNode;
    enabled?: boolean;
    className?: string;
    collapseButtonSize?: TriggerButtonProps["size"];
}

export const CollapsibleHeader: React.FC<Props> = ({
    isOpened,
    onToggle,
    panelId,
    children,
    actions,
    enabled = true,
    className,
    collapseButtonSize,
}) => (
    <header
        className={classNames(
            "collapsible__header",
            styles.collapsibleHeader,
            isOpened && styles.opened,
            className,
        )}
        onClick={enabled ? onToggle : undefined}
    >
        <div className="collapsible__header__content">{children}</div>

        <aside
            className={classNames(
                "collapsible__header__actions",
                styles.actions,
            )}
        >
            {actions}
            {enabled && (
                <Button
                    variant="secondary"
                    iconOnly
                    size={collapseButtonSize ?? "md"}
                    aria-label={
                        isOpened ? "Collapse section" : "Expand section"
                    }
                    aria-expanded={isOpened}
                    aria-controls={panelId}
                    onClick={(event) => {
                        event.stopPropagation();
                        onToggle();
                    }}
                >
                    {isOpened ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </Button>
            )}
        </aside>
    </header>
);
